import useSWR from 'swr';

import { meApiForClient } from '@/app/utils/apiForClient';

// TODO The key should contain auth token (cache)!!
export const useCurrentUser = () => {
  const { data, isLoading } = useSWR('/me', async () => await meApiForClient.getMe());

  return {
    isLoadingUser: isLoading,
    currentUser: data?.user,
  };
};
